import { render, staticRenderFns } from "./ProductFrames.vue?vue&type=template&id=6ed7478c&scoped=true&"
import script from "./ProductFrames.vue?vue&type=script&lang=ts&"
export * from "./ProductFrames.vue?vue&type=script&lang=ts&"
import style0 from "./ProductFrames.vue?vue&type=style&index=0&id=6ed7478c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7478c",
  null
  
)

export default component.exports